// removed by extract-text-webpack-plugin
module.exports = {"container":"c-RadioGroup__container","column":"c-RadioGroup__column"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/RadioGroup/RadioGroup.scss
// module id = 491
// module chunks = 0